import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid, Image, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import editSVG from '../../assets/images/icons/edit.svg';
import EditSVG from '../../assets/images/icons/edit.svg';
import EmptySVG from '../../assets/images/icons/empty.svg';
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';
import PaginationLeftSVG from '../../assets/images/icons/pagination-left.svg';
import PaginationRightSVG from '../../assets/images/icons/pagination-right.svg';

/*
    - api
*/
import get from '../../api/get';
import post from '../../api/post';

const List = ({ props, alertProps, reloadPassengerProps, paginationProps }) => {


    /*
       - defaultData
    */
    const [passengersResult, setPassengersResult] = React.useState('loading');
    const [nations, setNations] = React.useState('empty');
    const [editPassengerParameters, setEditPassengerParameters] = React.useState({
        id: '',
        firstName: {
            value: '',
            color: 'dark'
        },
        lastName: {
            value: '',
            color: 'dark'
        },
        nationalCode: {
            value: '',
            color: 'dark'
        },
        nationId: {
            value: '',
            color: 'dark'
        },
        nationality: false
    });
    const [removePassengerData, setRemovePassengerData] = React.useState({
        id: '',
        firstName: '',
        lastName: ''
    });

    React.useEffect(() => {
        if (props.passengers !== '') {
            if (props.passengers.status === 200 && props.passengers.data.Data.length > 0) {
                setPassengersResult(props.passengers.data);
            } else {
                setPassengersResult('empty')
            }
        }
        if (props.nations.status === 200) {
            setNations(props.nations.data);
        }
    }, [props]);

    /*
        - editPassengerHandler
    */
    const editPassengerHandler = (key, value) => {
        if (editPassengerParameters.nationality === false) {
            if (key === 'firstName' && (value === '' || !/^[آ-ی ]+$/.test(value))) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    firstName: {
                        value: value,
                        color: 'danger',
                    }
                });
            } else if (key === 'firstName') {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    firstName: {
                        value: value,
                        color: 'dark',
                    }
                });
            }
            if (key === 'lastName' && (value === '' || !/^[آ-ی ]+$/.test(value))) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    lastName: {
                        value: value,
                        color: 'danger',
                    }
                });
            } else if (key === 'lastName') {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    lastName: {
                        value: value,
                        color: 'dark',
                    }
                });
            }
            if (key === 'nationalCode') {
                if ((value.length === 10 && /^[0-9,۰-۹]+$/.test(value)) || value.length === 0) {
                    setEditPassengerParameters({
                        ...editPassengerParameters,
                        nationalCode: {
                            value: value,
                            color: 'dark',
                        }
                    });
                } else {
                    setEditPassengerParameters({
                        ...editPassengerParameters,
                        nationalCode: {
                            value: value,
                            color: 'danger',
                        }
                    });
                }
            }
        } else {
            if (key === 'firstName' && (value === '' || !/^[a-zA-Z ]+$/.test(value))) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    firstName: {
                        value: value,
                        color: 'danger',
                    }
                });
            } else if (key === 'firstName') {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    firstName: {
                        value: value,
                        color: 'dark',
                    }
                });
            }
            if (key === 'lastName' && (value === '' || !/^[a-zA-Z ]+$/.test(value))) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    lastName: {
                        value: value,
                        color: 'danger',
                    }
                });
            } else if (key === 'lastName') {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    lastName: {
                        value: value,
                        color: 'dark',
                    }
                });
            }
            if (key === 'nationalCode') {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    nationalCode: {
                        value: value,
                        color: 'dark',
                    }
                });
            }
            if (key === 'nationId' && value !== '') {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    nationId: {
                        value: value,
                        color: 'dark',
                    }
                });
            } else if (key === 'nationId') {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    nationId: {
                        value: value,
                        color: 'danger',
                    }
                });
            }
        }
    }

    /*
       - editPassenger
    */
    const editPassenger = async () => {
        let body = {};
        let isValid = 1;
        if (editPassengerParameters.nationality === false) {
            if (editPassengerParameters.firstName.value === '' || !/^[آ-ی ]+$/.test(editPassengerParameters.firstName.value)) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    firstName: {
                        value: editPassengerParameters.firstName.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (editPassengerParameters.lastName.value === '' || !/^[آ-ی ]+$/.test(editPassengerParameters.lastName.value)) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    lastName: {
                        value: editPassengerParameters.lastName.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (!(editPassengerParameters.nationalCode.value.length === 10 && /^[0-9,۰-۹]+$/.test(editPassengerParameters.nationalCode.value))) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    nationalCode: {
                        value: editPassengerParameters.nationalCode.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
        } else {
            if (editPassengerParameters.firstName.value === '' || !/^[a-zA-Z ]+$/.test(editPassengerParameters.firstName.value)) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    firstName: {
                        value: editPassengerParameters.firstName.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (editPassengerParameters.lastName.value === '' || !/^[a-zA-Z ]+$/.test(editPassengerParameters.lastName.value)) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    lastName: {
                        value: editPassengerParameters.lastName.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (editPassengerParameters.nationalCode.value.length === 0) {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    nationalCode: {
                        value: editPassengerParameters.nationalCode.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (editPassengerParameters.nationId.value === '') {
                setEditPassengerParameters({
                    ...editPassengerParameters,
                    nationId: {
                        value: editPassengerParameters.nationId.value,
                        color: 'danger',
                    }
                });
                isValid = 0;
            }
        }
        if (isValid === 1) {
            body.Id = editPassengerParameters.id;
            body.Name = editPassengerParameters.firstName.value;
            body.Family = editPassengerParameters.lastName.value;
            body.NationalCode = editPassengerParameters.nationalCode.value;
            body.NationId = editPassengerParameters.nationId.value;
            body.Nationality = editPassengerParameters.nationality;
            let parameters = {
                ctrl: 'SiteUserPassenger',
                method: 'Edit',
                query: '',
                body: body
            };
            let result = await post(parameters);
            if (result.status === 200) {
                closeModal('editGuestModal');
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadPassengerProps(Math.floor(Math.random() * 100));
            } else {
                closeModal('editGuestModal');
                alertProps(['danger', result.data.Message]);
            }
        }
    }

    /*
       - removePassenger
    */
    const removePassenger = async () => {
        let parameters = {
            ctrl: 'SiteUserPassenger',
            method: 'Delete',
            query: removePassengerData.id
        };
        let result = await get(parameters);
        if (result.status) {
            closeModal('removeGuestModal');
            alertProps(['success', 'با موفقیت انجام شد']);;
            reloadPassengerProps(Math.floor(Math.random() * 100));
        } else {
            closeModal('removeGuestModal');
            alertProps(['danger', result.data.Message]);
        }
    }

    /*
       - modal
    */
    const openModal = (modal, data) => {
        if (modal === 'editGuestModal') {
            document.querySelector(`.editGuestModal`).classList.remove('d-none');
            setEditPassengerParameters({
                id: data.Id,
                firstName: {
                    value: data.Name,
                    color: 'dark'
                },
                lastName: {
                    value: data.Family,
                    color: 'dark'
                },
                nationalCode: {
                    value: data.NationalCode,
                    color: 'dark'
                },
                nationId: {
                    value: data.NationId,
                    color: 'dark'
                },
                nationality: data.Nationality
            });
        }
        if (modal === 'removeGuestModal') {
            document.querySelector(`.removeGuestModal`).classList.remove('d-none');
            setRemovePassengerData({
                id: data.Id,
                firstName: data.Name,
                lastName: data.Family
            });
        }
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    if (passengersResult === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (passengersResult === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block text-center`}
                        component='h2'>
                        لیست مهمان ها خالی است :(
                    </Typography>
                    <Box
                        className={`my-md`} />
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                        تاکنون هیچ مهمانی ثبت نشده است!
                    </Typography>
                </Box>
            </React.Fragment>
        );
    }

    if (passengersResult !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            size='col-12'>
                            <Box
                                ms={{
                                    '@media(max-width:576px)': {
                                        overflowX: 'scroll'
                                    }
                                }}>
                                <Box
                                    ms={{
                                        minWidth: '576px'
                                    }}>
                                    <Box
                                        className={`d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--gray-light)'
                                        }}>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                            کد ملی / پاسپورت
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                                نام
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                                نام خانوادگی
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block w-25`} />
                                    </Box>
                                    <Box
                                        className={`border-solid border-light rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--white)'
                                        }}>
                                        {passengersResult.Data.map((obj, index) => {
                                            return (
                                                <Box
                                                    key={index}>
                                                    <Box
                                                        className={`d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                        <Box
                                                            className={`w-25`}>
                                                            {obj.NationalCode}
                                                        </Box>
                                                        <Box
                                                            className={`w-25`}>
                                                            {obj.Name}
                                                        </Box>
                                                        <Box
                                                            className={`w-25`}>
                                                            {obj.Family}
                                                        </Box>
                                                        <Box
                                                            className={`d-flex justify-content-end align-item-center w-25`}>
                                                            <Image
                                                                className={`pointer`}
                                                                onClick={() => openModal('editGuestModal', obj)}
                                                                src={editSVG}
                                                                ms={{
                                                                    width: '16px',
                                                                    height: '16px'
                                                                }} />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                        <Box
                                            className={`d-flex justify-content-center rounded-sm rounded-top-right-0 rounded-top-left-0`}
                                            ms={{
                                                height: '56px',
                                                backgroundColor: 'var(--gray-ultra-light)'
                                            }}>
                                            <Box
                                                className={`d-flex justify-content-center align-item-center`}
                                                ms={{
                                                    gap: '16px'
                                                }}>
                                                <Button
                                                    onClick={() => paginationProps(-1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationRightSVG} />
                                                </Button>
                                                <Typography
                                                    className={`text-primary`}>
                                                    {passengersResult.PageIndex} / {Math.ceil(passengersResult.TotalItems / passengersResult.PageSize)}
                                                </Typography>
                                                <Button
                                                    onClick={() => paginationProps(1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationLeftSVG} />
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
                <Modal
                    className={`editGuestModal`}>
                    <Modal.Wrapper
                        size='xs'
                        ms={{
                            '@media(max-width:576px)': {
                                width: '100% !important'
                            }
                        }}>
                        <Modal.Header
                            className={`my-md mt-0 border-solid-bottom border-light`}>
                            ویرایش مهمان
                            <Box />
                        </Modal.Header>
                        <Typography
                            className={`px-lg`}>
                            اطلاعات همراه و یا مهمان خود را ویرایش نمایید.
                        </Typography>
                        <Box
                            className={`p-sm`}
                            component='form'>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <TextField
                                            onChange={(value) => editPassengerHandler('firstName', value)}
                                            color={editPassengerParameters.firstName.color}
                                           label='نام *'
                                            icon={EditSVG}
                                            value={editPassengerParameters.firstName.value} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <TextField
                                            onChange={(value) => editPassengerHandler('lastName', value)}
                                            color={editPassengerParameters.lastName.color}
                                            label='نام خانوادگی *'
                                            icon={EditSVG}
                                            value={editPassengerParameters.lastName.value} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <TextField
                                            onChange={(value) => editPassengerHandler('nationalCode', value)}
                                            color={editPassengerParameters.nationalCode.color}
                                            label='کد ملی (شماره پاسپورت) *'
                                            icon={EditSVG}
                                            value={editPassengerParameters.nationalCode.value} />
                                    </Grid.Item>
                                    {editPassengerParameters.nationality === true &&
                                        <Grid.Item
                                            size='col-12'>
                                            <Select
                                                onChange={(value) => editPassengerHandler('nationId', value)}
                                                color={editPassengerParameters.nationId.color}
                                                 label='ملیت *'     
                                                search
                                                init={editPassengerParameters.nationId.value}>
                                                {nations.map((obj, index) => {
                                                    return (
                                                        <Select.Item
                                                            key={index}
                                                            value={obj.id}>
                                                            {obj.nationTitle}
                                                        </Select.Item>
                                                    )
                                                })}
                                            </Select>
                                        </Grid.Item>
                                    }
                                    <Grid.Item
                                        className={`d-flex pb-0`}
                                        size='col-12 md-6'>
                                        <Button
                                            onClick={editPassenger}
                                            className={`w-25`}
                                            variant='filled'
                                            color='primary'>
                                            تایید
                                        </Button>
                                        <Box
                                            className={`d-inline-block mx-sm`} />
                                        <Button
                                            onClick={() => closeModal('editGuestModal')}
                                            className={`w-25`}
                                            variant='outlined'
                                            color='primary'>
                                                انصراف
                                        </Button>
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Box>
                    </Modal.Wrapper>
                </Modal>
                <Modal
                    className={`removeGuestModal`}>
                    <Modal.Wrapper
                        size='xs'
                        ms={{
                            '@media(max-width:576px)': {
                                width: '100% !important'
                            }
                        }}>
                        <Modal.Header
                            className={`my-md mt-0 border-solid-bottom border-light`}>
                            حذف مهمان
                            <Box />
                        </Modal.Header>
                        <Typography
                            className={`px-lg`}>
                            آیا حذف مهمان انتخاب شده
                            ({removePassengerData.firstName} {removePassengerData.lastName})
                            را تایید می نمایید؟
                        </Typography>
                        <Box
                            className={`p-sm`}
                            component='form'>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        className={`d-flex pb-0`}
                                        size='col-6'>
                                        <Button
                                            onClick={removePassenger}
                                            variant='filled'
                                            color='danger'>
                                            تایید
                                        </Button>
                                        <Box
                                            className={`mx-sm`} />
                                        <Button
                                            onClick={() => closeModal('removeGuestModal')}
                                            variant='outlined'
                                            color='primary'>
                                            انصراف
                                        </Button>
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Box>
                    </Modal.Wrapper>
                </Modal>
            </React.Fragment>
        );
    }

}

export default List;